import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
import Button from '../../storybook/Button';
import mobileChevronleft from "../../assets/img/mobileChevronleft.png";

import { RouteComponentProps } from 'react-router-dom';
import HeaderJourney from "../../storybook/Header/HeaderJourney";
import { showFooter, showMenuTabs } from "../../ducks/redux/actions/userChoices";
import { useDispatch } from "react-redux";

interface PaymentGatewayFailureProps extends RouteComponentProps<any> {
}

const PaymentFailure: React.FC<PaymentGatewayFailureProps> = (props) => {
    const {t} = useTranslation();
    const dispatch =  useDispatch();

        useEffect(()=>{
            dispatch(showMenuTabs(false));
            dispatch(showFooter(false));
        },[])


    const backButtonHandler = () => {
         props.history.push("/viewaccount");
    };
    return (
        <div className="pg-flex-container">
        <HeaderJourney />
            <div className="payment-failure-container">
                <p className="payment-failure-title">
                    {t("Payment_Failure_Title")}
                </p>
                <p className="payment-failure-alternate">
                    {t("Payment_Failure_Msg_Alternate")}
                </p>
                <p className="payment-failure-note">
                    {t("Payment_Failure_Msg")}
                </p>
            </div>
             {/* Footer */}
            <div className="col-md-12 marginTop-auto mb-4">
                    <div className="row m-0 footer-actionbtn">
                        <div className="col btn-top padding-repair mb-0">
                            <span className="payment-backbtn"><Button
                                data-testid="back-button"
                                onClick={backButtonHandler}
                                className="secondary-ghost-btn"
                            >
                                {t("Go_To_Account")}
                            </Button>
                            </span>
                            <span className="payment-backarrow"><img src={mobileChevronleft} onClick={backButtonHandler} onKeyDown={backButtonHandler} alt="Back" /></span>
                        </div>
                    </div>
                </div>
        </div>
    );
};

export default PaymentFailure;
